import React, { Component } from 'react';
import cn from 'classnames';
import { parse } from 'query-string';
import { omit } from 'lodash';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { Form, FormGroup, Input, Label, Button } from 'reactstrap';
import { object, func } from 'prop-types';
import CustomControl from '../CustomControl/CustomControl';
import { iFMessage } from '../../hoc/IntlComponents';
import Upload from '../common/Upload/Upload';

export class TicketForm extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
    submit: func.isRequired,
    offer: object,
  };

  static defaultProps = {
    offer: {},
  };

  constructor(props) {
    super(props);
    const { title, placeholder } = this.getStartProps();
    const { formData = {} } = props;

    this.state = {
      loading: false,
      data: {
        title: formData.title || title,
        text: formData.text || '',
        level: formData.level || '0',
        'uploads[]': [],
      },
      errors: {},
      placeholder,
      withoutLevels: false,
    };
  }

  getStartProps = () => {
    const {
      history: { location },
      intl,
    } = this.props;
    const query = parse(location.search);
    let title = '';
    let placeholder = iFMessage({ intl, id: 'tickets.msg.text' });
    if (query.sitekey && query.sitekey === 'site_key') {
      title = iFMessage({ intl, id: 'tickets.site-key.theme' });
      placeholder = iFMessage({ intl, id: 'tickets.site-key.message.placeholder' });
    } else if (query.theme && query.theme === 'masterAccount') {
      title = iFMessage({ intl, id: 'tickets.theme.become-master.title' });
      placeholder = iFMessage({ intl, id: 'tickets.theme.become-master.placeholder' });
    } else if (query.sitekey && query.sitekey === 'update_key') {
      title = iFMessage({ intl, id: 'tickets.theme.update-key.title' });
      placeholder = iFMessage({ intl, id: 'tickets.theme.update-key.placeholder' });
    } else if (query.theme && query.theme === 'enableApps') {
      title = iFMessage({ intl, id: 'tickets.theme.enable-apps.title' });
      placeholder = iFMessage({ intl, id: 'tickets.theme.enable-apps.placeholder' });
    } else if (query.theme && query.theme === 'earlyPayRequest') {
      title = iFMessage({ intl, id: 'tickets.theme.early-pay.title' });
      placeholder = iFMessage({ intl, id: 'tickets.theme.early-pay.placeholder' });
    } else if (query.theme && query.theme === 'RequestForAccessToTheSpOffer') {
      title = iFMessage({ intl, id: 'tickets.theme.access-sp-offer.title' });
      placeholder = iFMessage({ intl, id: 'tickets.theme.access-sp-offer.placeholder' });
    }
    return { title, placeholder };
  };

  componentDidMount() {
    const { offer, theme, onChange } = this.props;
    if (theme) {
      if (theme === 'offerRequest') {
        if (offer.id) {
          const title = this.props.intl.formatMessage({
            id: 'tickets.request-offer',
            defaultMessage: 'Request for offer connection',
          });

          const text = this.props.intl.formatMessage(
            {
              id: 'tickets.request-offer-text',
              defaultMessage: 'Please provide me access to {offer}',
            },
            {
              offer: offer.title,
            },
          );

          this.setState((prevState) => ({
            data: {
              ...prevState.data,
              title,
              text,
            },
          }));

          if (onChange) {
            onChange({ target: { name: 'title', value: title } });
            onChange({ target: { name: 'text', value: text } });
          }
        }
      } else if (theme === 'pixelRequest') {
        const title = this.props.intl.formatMessage(
          {
            id: 'tickets.theme.pixel-request.title',
            defaultMessage: 'Request payout for {offer}',
          },
          {
            offer: offer.title,
          },
        );

        const placeholder = this.props.intl.formatMessage({
          id: 'tickets.theme.pixel-request.placeholder',
          defaultMessage:
            "Is there any other affiliate network with such payout and geo? Also please provide your excepted volume in case of payout's increase",
        });

        this.setState((prevState) => ({
          data: {
            ...prevState.data,
            title,
          },
          placeholder,
        }));

        if (onChange) {
          onChange({ target: { name: 'title', value: title } });
        }
      } else if (theme === 'offChecksCashOut') {
        const title = this.props.intl.formatMessage({
          id: 'tickets.theme.off-checks-cash-out.title',
          defaultMessage: 'Request for OFF-checks cash out',
        });

        const text = this.props.intl.formatMessage({
          id: 'tickets.theme.off-checks-cash-out.text',
          defaultMessage: '',
        });

        this.setState((prevState) => ({
          data: {
            ...prevState.data,
            title,
            text,
          },
          withoutLevels: true,
        }));

        if (onChange) {
          onChange({ target: { name: 'title', value: title } });
          onChange({ target: { name: 'text', value: text } });
        }
      } else if (theme === 'geoRequest') {
        const title = this.props.intl.formatMessage(
          {
            id: 'tickets.theme.geo-request.title',
            defaultMessage: 'Request GEO for {offer}',
          },
          {
            offer: offer.title,
          },
        );

        const placeholder = this.props.intl.formatMessage({
          id: 'tickets.theme.geo-request.placeholder',
          defaultMessage:
            'Please provide a geo you are interested in, as well as a willing payout and excepted volume. If you noticed this geo in other affiliate network, please provide its title',
        });

        this.setState((prevState) => ({
          data: {
            ...prevState.data,
            title,
          },
          placeholder,
        }));

        if (onChange) {
          onChange({ target: { name: 'title', value: title } });
        }
      } else if (theme === 'highLevelAccessRequest') {
        const title = this.props.intl.formatMessage(
          {
            id: 'tickets.theme.high-level-access.title',
            defaultMessage: 'Request to increase access for {offer}',
          },
          {
            offer: offer.title,
          },
        );

        const placeholder = this.props.intl.formatMessage({
          id: 'tickets.theme.high-level-access.placeholder',
          defaultMessage:
            'Describe the sources of traffic you plan to use, as well as your experience with them.',
        });

        this.setState((prevState) => ({
          data: {
            ...prevState.data,
            title,
          },
          placeholder,
          withoutLevels: true,
        }));

        if (onChange) {
          onChange({ target: { name: 'title', value: title } });
        }
      } else if (theme === 'getPrivateOffers') {
        const title = this.props.intl.formatMessage({
          id: 'tickets.theme.getPrivateOffers.title',
          defaultMessage: 'Increase Access Level!',
        });

        const placeholder = this.props.intl.formatMessage({
          id: 'tickets.theme.getPrivateOffers.placeholder',
          defaultMessage:
            'Describe the sources of traffic you plan to use, as well as your experience with them.',
        });

        this.setState((prevState) => ({
          data: {
            ...prevState.data,
            title,
          },
          placeholder,
          withoutLevels: true,
        }));

        if (onChange) {
          onChange({ target: { name: 'title', value: title } });
        }
      }
    }
  }

  onFilesChange = (file) => {
    this.setState((prevState) => {
      return {
        data: {
          ...prevState.data,
          'uploads[]': [...prevState.data['uploads[]'], file],
        },
      };
    });
  };

  onDeleteFile = (deleteIndex) => {
    this.setState((prevState) => {
      return {
        ...prevState,
        data: {
          ...prevState.data,
          'uploads[]': prevState.data['uploads[]'].filter((item, index) => index !== deleteIndex),
        },
      };
    });
  };

  onSubmit = (e) => {
    e.preventDefault();
    const { data } = this.state;
    const { offer, theme, submit, offerId } = this.props;
    const errors = this.validate(data);

    this.setState(() => ({ errors }));

    if (Object.keys(errors).length === 0) {
      this.setState(
        () => ({ loading: true }),
        () => {
          let params = { ...data, offerId: offer.id || offerId };

          switch (theme) {
            case 'pixelRequest':
            case 'geoRequest':
              params = omit(params, ['offerId', 'masterAccount']);
            case 'masterAccount':
              params = { ...data, masterAccount: 1 };
          }
          submit(params);
        },
      );
    }
  };

  validate = (data) => {
    const errors = {};

    if (!data.text) {
      errors.text = this.props.intl.formatMessage({
        id: 'tickets.field.required',
        defaultMessage: 'This field is required',
      });
    }

    return errors;
  };

  componentDidUpdate(prevProps) {
    const prevFormData = prevProps.formData || {};
    const currentFormData = this.props.formData || {};

    if (
      prevFormData.text !== currentFormData.text ||
      prevFormData.title !== currentFormData.title ||
      prevFormData.level !== currentFormData.level
    ) {
      this.setState((prev) => ({
        data: {
          ...prev.data,
          text: currentFormData.text || '',
          title: currentFormData.title || '',
          level: currentFormData.level || '0',
        },
      }));
    }
  }

  render() {
    const { errors, withoutLevels, data } = this.state;
    const { intl, theme, onChange } = this.props;
    const { text = '', title = '', level = '0' } = data;

    return (
      <Form
        onSubmit={this.onSubmit}
        autoComplete="off"
        className={cn('create-ticket-form', {
          'ticket-urgency-wrapper-withoutLevels': withoutLevels,
        })}
      >
        <FormGroup className={cn('form-group-upper-label', { 'has-error': errors.title })}>
          <Label htmlFor="ticket_title">
            <FormattedMessage id="tickets.title" defaultMessage="Ticket title" />
          </Label>

          <Input
            id="ticket_title"
            name="title"
            value={title}
            readOnly={~['highLevelAccessRequest'].indexOf(theme)}
            onChange={onChange}
          />

          {errors.title && <small className="form-text">{errors.title}</small>}
        </FormGroup>
        <FormGroup className={cn('form-group-upper-label', { 'has-error': errors.text })}>
          <Label htmlFor="ticket_text">
            <FormattedMessage id="tickets.msg" defaultMessage="Message" />
          </Label>
          <Input
            id="ticket_text"
            type="textarea"
            name="text"
            rows="10"
            value={text}
            onChange={onChange}
          />
          {errors.text && <small className="form-text">{errors.text}</small>}
        </FormGroup>

        <Upload type="file" onChange={this.onFilesChange} onDelete={this.onDeleteFile} />

        <div className="create-ticket-form-actions">
          {!withoutLevels && (
            <div className="ticket-urgency-wrapper">
              <CustomControl
                type="radio"
                name="level"
                onChange={onChange}
                value="0"
                id="ticket_urgency_0"
                checked={level === '0'}
                className={cn('ticket-urgency-control-btn ', {
                  ['ticket-urgency-control-btn-checked']: level === '0',
                })}
                label={intl.formatMessage({ id: 'tickets.normal', defaultMessage: 'Normal' })}
              />
              <CustomControl
                type="radio"
                name="level"
                onChange={onChange}
                value="1"
                id="ticket_urgency_1"
                checked={level === '1'}
                className={cn('ticket-urgency-control-btn ', {
                  ['ticket-urgency-control-btn-checked']: level === '1',
                })}
                label={intl.formatMessage({
                  id: 'tickets.important',
                  defaultMessage: 'Important',
                })}
              />
              <CustomControl
                type="radio"
                name="level"
                onChange={onChange}
                value="2"
                id="ticket_urgency_2"
                checked={level === '2'}
                className={cn('ticket-urgency-control-btn', {
                  ['ticket-urgency-control-btn-checked']: level === '2',
                })}
                label={intl.formatMessage({ id: 'tickets.urgent', defaultMessage: 'Urgent' })}
              />
            </div>
          )}

          <Button color="primary create-ticket-form-btn" disabled={!text}>
            <FormattedMessage id="tickets.create_ticket" defaultMessage="Create Ticket" />
          </Button>
        </div>
      </Form>
    );
  }
}

export default injectIntl(TicketForm);
